import Vue from 'vue';
import Vuex from 'vuex';
import io from 'socket.io-client';
import storage from './storage';
import router from './router';
import eventHub from './mixins/eventHub';
import loginBus from './bus/loginBus';

import timingPlugin from './plugins/timingPlugin';
import storagePlugin from './plugins/storagePlugin';
import getSocketPlugin from './plugins/socketPlugin';

import i18n from './plugins/i18n'


Vue.use(Vuex);
const relativePath = (process.env.VUE_APP_SOCKET_PATH || '');
const socketUrl = process.env.VUE_APP_SOCKET_SERVER || 'http://localhost:3000';
console.log(socketUrl);
const socket = io.connect(socketUrl, {path: relativePath});
const socketPlugin = getSocketPlugin(socket);

//const debug = process.env.NODE_ENV !== 'production'

var prevState = 'stop';

function getEmptySimulation() {
  return {
    id: null,
    entities:{},
    lists:{},
    properties:{

    },
    time: 0,
    progress: 0
  }
}

export default new Vuex.Store({

  state: {
    online: false,
    auth:{
      logged: false,
      user: null,
      simId: null,
      token: null,
      status: 'default'
    },
    time:{},
    simulation: getEmptySimulation(),
    simulationList: [],
    editMode: false,
    loaded: false,
    appState: 'loading',
    scenarioSelected: false,
    version: process.env.VUE_APP_VERSION_VALUE,
    selected: {
      entityId: null,
      events: [],
      crews: [],
      hospitals: [],
      bases: [],
      log: []
    }
  },
  mutations: {
    callApi(state, payload){
      console.log(payload)
    },
    setEditMode(state, value){
      state.editMode = value;
      console.log(state.value);
    },
    setSelected(state, payload){
      state.selected[payload.property] = payload.value;
      state.selected.entityId = payload.value[0];
    },
    clearSelected(state) {
        state.selected.events = [];
        state.selected.crews = [];
        state.selected.hospitals = [];
        state.selected.bases = [];
        state.selected.log = [];
        state.selected.entityId = -1;
    },
    setLog(state, payload){
      state.selected.log.push({
        time: payload.time,
        entityId: payload.entityId,
        text: payload.text
      })
      /*
      state.selected.log[0].entityId = payload.entityId;
      state.selected.log[0].time = payload.time;
      state.selected.log[0].text = payload.text;*/
    },
    clearLog(state) {
      state.selected.log = []; // clear log
    },
    clearCrews(state) {
      state.selected.crews = []; // clear selected crews
    },
    hideAllCrews(state) {
      state.selected.crews = ["no crews selected"]; // clear selected crews
    },
    hideAllBases(state) {
      state.selected.bases = ["no bases selected"]; // clear selected bases
    },
    hideAllEvents(state) {
      state.selected.events = ["no event selected"];
    },
    hideAllHospitals(state) {
      state.selected.hospitals = ["no hospital selected"];
    },
    refreshTime(state){
      const now = new Date().getTime();

      const startTime = state.simulation.properties.startTime || 1604185200000;  // 1604185200000  = unix time for 1.11.2020

      const at = state.simulation.properties.at || 0;
      let progress = state.simulation.properties.progress || 0;
      const updated = state.simulation.properties.updated || 0;
      const simulationState = state.simulation.properties.state;

      const serverOffset = updated-at;

      const diff = now - serverOffset - at;
      if(simulationState === 'play'){
          progress += diff;
      }
      Vue.set(state.time, 'progress', progress);
      Vue.set(state.time, 'time', startTime+progress);
    },
    online(state){
      state.online = true;
      eventHub.$emit('openMessageController', 'success' , 'Online');
    },
    offline(state){
      state.online = false;
      eventHub.$emit('openMessageController', 'error' , 'Offline');
    },
    simulationData(state, data){
      Vue.set(state, 'simulation', data);
      Vue.set(state.simulation.properties, 'updated', new Date().getTime());
      const simulation = state.simulation;

      if (prevState != simulation.properties.state) {
        if (simulation.properties.state == 'play') {
            eventHub.$emit('openMessageController', 'success' , i18n.tc('Popups.text20'));
        } else if (simulation.properties.state == 'stop') {
          eventHub.$emit('openMessageController', 'error' , i18n.tc('Popups.text21'));
        } else if (simulation.properties.state == 'pause') {
          eventHub.$emit('openMessageController', 'error' , i18n.tc('Popups.text22'));
        }
        prevState = simulation.properties.state;
      }
      state.loaded = !!simulation.properties.simId;
      state.appState = (simulation.properties.simId)?'ready':'waiting';
      state.scenarioSelected = !!simulation.properties.simId;

    },
    sendCMD(){
      //plugin
    },
    authorizeCMD(){
      //plugin
    },
    setToken(){
      //plugin
    },
    resetToken(){
      //plugin
    },
    login(state){
      Vue.set(state.auth, 'status', 'pending');
    },
    loggedId(state, res){
      const {user, token} = res;
      Vue.set(state.auth, 'logged', true);
      Vue.set(state.auth, 'user', user);
      Vue.set(state.auth, 'token', token);
      Vue.set(state.auth, 'status', 'ok');
    },
    loginFailed(state, status){
      Vue.set(state.auth, 'logged', false);
      Vue.set(state.auth, 'user', null);
      Vue.set(state.auth, 'token', null);
      Vue.set(state.auth, 'simId', null);
      Vue.set(state.auth, 'status', status);
    },
    logout(state){
      Vue.set(state.auth, 'logged', false);
      Vue.set(state.auth, 'user', null);
      Vue.set(state.auth, 'token', null);
      Vue.set(state.auth, 'simId', null);
      Vue.set(state.auth, 'status', 'not authenticated');
      Vue.set(state, 'simulation', getEmptySimulation());
    },
    setSimulations(state, simulations){
      Vue.set(state, 'simulationList', simulations);
    }
  },
  getters: {
    getEntity: (state) => (entityId) => {
      return state.simulation.entities[entityId];
    },
    isEntityScenarioChange: (state) => (entityId) => {
      return !!state.simulation.entities[entityId].isScenarioChange;
    },
    getPropertyValue: (state) => (entityId, property) => {
      const entity = state.simulation.entities[entityId];
      if(entity && entity.properties.hasOwnProperty(property)){
        return entity.properties[property].value;
      }
    },
    isPropertyScenarioChange: (state) => (entityId, property) => {
      const entity = state.simulation.entities[entityId];
      if(entity && entity.properties.hasOwnProperty(property)){
        return !!entity.properties[property].isScenarioChange;
      }
    },
    getPropertyExtension: (state) => (entityId, property) => {
        const entity = state.simulation.entities[entityId];
        if(entity && entity.properties.hasOwnProperty(property)){
          return entity.properties[property].extension;
        }
    }
  },
  actions: {
    async authorizeCMD({commit}, call){
      commit('authorizeCMD', call);
      return await new Promise((resolve, reject)=>{
        socket.emit('authorizeCMD', call, (error, payload)=>{
          if(error){
            console.error(error);
            reject(error);
          } else {
            resolve(payload);
          }
        });
      });
    },
    async setSelectedEntities({commit}, entityIds){
      const call = {cmd: 'setSelectedEntities', payload: {entityIds}};
      commit('sendCMD', call);
      return await new Promise((resolve, reject)=>{
        socket.emit('cmd', call, (error, payload)=>{
          if(error){
            console.error(error);
            reject(error);
          } else {
            resolve(payload);
          }
        });
      });
    },
    async sendCommand({commit}, call){
      commit('sendCMD', call);
      return await new Promise((resolve, reject)=>{
        socket.emit('cmd', call, (error, payload)=>{
          if(error){
            console.error(error);
            reject(error);
          } else {
            resolve(payload);
          }
        });
      });
    },
    async callApi({commit}, call){
      commit('callApi', call);
      return await new Promise((resolve, reject)=>{
        socket.emit('callApi', call, (error, payload)=>{
          if(error){
            console.error(error);
            reject(error);
          } else {
            resolve(payload);
          }
        });
      });
    },
    async checkToken({dispatch}){
      const storedToken = storage.isLSAvailable?localStorage.getItem('authenticationToken'):undefined;
      if(storedToken){
        console.log('Login via stored token');
        try{
          return await dispatch('login', {method:'token', token: storedToken});
        } catch(e){
          console.error(e);
        }
      }
      loginBus.$emit('loginFailed');
    },
    async login({commit, dispatch}, payload){
      const {method} = payload;
      try{
        commit('login');

        const loginResult =  await new Promise(async (resolve, reject) => {
          socket.emit('login', payload, async (error, payload) => {
            try {
              if (error) {
                reject(error);
              } else {
                const token = payload.token;
                const user = await dispatch('callApi', {name: 'getUser'});
                commit('loggedId', {user, token});
                commit('setToken', token);

                loginBus.$emit('login');
                resolve({user, token});
              }
            } catch (e) {
              reject(e);
            }
          });
        });
        console.log(`Login method: ${method}`);
        if(method !== 'token') {
          try {
            const simId = await dispatch('getSimId');
            if (!simId) {
              await dispatch('gotoScenarios');
            }
          }
          catch(e){
            await dispatch('gotoScenarios');
          }
        }
        return loginResult;
      } catch (e){
        console.error('Login failed!', e);
        commit('loginFailed', e.message);
        commit('resetToken');
        loginBus.$emit('loginFailed');
        throw e;
      }
    },
    async logout({commit, dispatch}){
      console.log('logout started');
      try{
        await new Promise((resolve, reject) => {
          socket.emit('logout', (error, payload)=>{
            if(error){
              reject(error);
            } else {
              resolve(payload);
            }
          });
        });
        commit('logout');
        commit('resetToken');
        await dispatch('gotoLogin');
      } catch(e){
        console.error(e);
      }
    },
    async gotoLogin(){
      if(router.history.current.name !== 'Login'){
        await router.push({name:'Login', query: { redirect: router.history.current.path}});
      } else {
        console.log('Stay at login');
      }
    },
    async gotoScenarios(){
      if(router.history.current.name !== 'Controls'){
        await router.push({name:'Controls'});
      } else {
        console.log('Stay at scenarios');
      }
    },
    async getSimId({dispatch}){
      return dispatch('callApi', {
        name: 'getSimId'
      });
    }
  },
  plugins: [socketPlugin, timingPlugin, storagePlugin.plugin]
})
